// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#pdf-viewer {
  width: 100%;
  height: 100%;
  display: flex;
  margin: 0 auto;
  flex-direction: column;
}

#pdf-viewer .btn-default > i.mdi  {
  color: #FFF;
}

#toolbar {
  display: flex;
  align-items: center;
  background-color: #1f2f46;
  color: #fff;
  padding: 8px;
}
#toolbar button,
#page-mode input {
  background-color: transparent;
}
#page-mode {
  display: flex;
  align-items: center;
  padding: 0.25em 0.5em;
}

#viewport-container {
  flex: 1;
  background: #eee;
  overflow: auto;
}
#viewport {
  width: 95%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
#viewport > div {
  text-align: center;
  max-width: 100%;
}
#viewport canvas {
  width: 100%;
  box-shadow: 0 2px 5px gray;
}
`, "",{"version":3,"sources":["webpack://./src/modules/interface/directives/pmdPdf/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B","sourcesContent":["#pdf-viewer {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  margin: 0 auto;\n  flex-direction: column;\n}\n\n#pdf-viewer .btn-default > i.mdi  {\n  color: #FFF;\n}\n\n#toolbar {\n  display: flex;\n  align-items: center;\n  background-color: #1f2f46;\n  color: #fff;\n  padding: 8px;\n}\n#toolbar button,\n#page-mode input {\n  background-color: transparent;\n}\n#page-mode {\n  display: flex;\n  align-items: center;\n  padding: 0.25em 0.5em;\n}\n\n#viewport-container {\n  flex: 1;\n  background: #eee;\n  overflow: auto;\n}\n#viewport {\n  width: 95%;\n  margin: 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n#viewport > div {\n  text-align: center;\n  max-width: 100%;\n}\n#viewport canvas {\n  width: 100%;\n  box-shadow: 0 2px 5px gray;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
